var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      _vm.loading > 0
        ? [_c("Loader", { attrs: { delay: 0 } })]
        : [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "IDI" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.id,
                                callback: function($$v) {
                                  _vm.id = $$v
                                },
                                expression: "id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.type === "caldera"
                  ? _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detalles.codigo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.detalles, "codigo", $$v)
                                    },
                                    expression: "detalles.codigo"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Categoria GN" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Categoria GN",
                                options: _vm.categoria_gn_options,
                                "text-field": "categoria_gn_" + _vm.type,
                                "value-field": "id",
                                disabled: !_vm.hasPermision("B")
                              },
                              on: {
                                input: function($event) {
                                  _vm.loadTipo(false)
                                }
                              },
                              model: {
                                value:
                                  _vm.detalles["id_categoria_gn_" + _vm.type]
                                    .id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles["id_categoria_gn_" + _vm.type],
                                    "id",
                                    $$v
                                  )
                                },
                                expression:
                                  "detalles['id_categoria_gn_'+type].id"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first(
                                    "identificacion.Categoria GN"
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Tipo establecimiento" }
                          },
                          [
                            _c("multiselect", {
                              attrs: {
                                placeholder: "Seleccionar una opción",
                                selectedLabel: "Seleccionada",
                                "deselect-label":
                                  "Click o enter para deseleccionar",
                                "select-label":
                                  "Click o enter para seleccionar",
                                "tag-placeholder": "Seleccionar",
                                options: _vm.tipo_establecimiento_gn_options,
                                label: "tipo",
                                "track-by": "id",
                                disabled:
                                  _vm.tipo_establecimiento_gn_options.length ===
                                    0 || !_vm.hasPermision("B")
                              },
                              on: { close: _vm.closedTipoEstablecimiento },
                              model: {
                                value:
                                  _vm.detalles[
                                    "id_tipo_establecimiento_gn_" + _vm.type
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "id_tipo_establecimiento_gn_" + _vm.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "detalles['id_tipo_establecimiento_gn_'+type]"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(_vm.customErrors["tipo_establecimiento"])
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.type === "comercial"
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Nombre establecimiento" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "Nombre establecimiento",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value: _vm.detalles.nombre,
                                    callback: function($$v) {
                                      _vm.$set(_vm.detalles, "nombre", $$v)
                                    },
                                    expression: "detalles.nombre"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "identificacion.Nombre establecimiento"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Código CNAE" }
                              },
                              [
                                _c("multiselect", {
                                  attrs: {
                                    placeholder: "Seleccionar una opción",
                                    selectedLabel: "Seleccionada",
                                    "deselect-label":
                                      "Click o enter para deseleccionar",
                                    "select-label":
                                      "Click o enter para seleccionar",
                                    "tag-placeholder": "Seleccionar",
                                    "custom-label": _vm.customLabelCNAE,
                                    options: _vm.cnae_options,
                                    label: "descripcion",
                                    "track-by": "id",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value: _vm.detalles.codigo_cnae,
                                    callback: function($$v) {
                                      _vm.$set(_vm.detalles, "codigo_cnae", $$v)
                                    },
                                    expression: "detalles.codigo_cnae"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm.type === "caldera"
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Tipo caldera" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "Tipo caldera",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value:
                                      _vm.detalles_ext.caldera_centralizada,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.detalles_ext,
                                        "caldera_centralizada",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detalles_ext.caldera_centralizada"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "identificacion.Tipo caldera"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Mercado" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "Mercado",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value: _vm.detalles_ext.mercado,
                                    callback: function($$v) {
                                      _vm.$set(_vm.detalles_ext, "mercado", $$v)
                                    },
                                    expression: "detalles_ext.mercado"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first("identificacion.Mercado")
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Gas en finca" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "Gas en finca",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value: _vm.detalles.id_gas_en_finca.gas,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.detalles.id_gas_en_finca,
                                        "gas",
                                        $$v
                                      )
                                    },
                                    expression: "detalles.id_gas_en_finca.gas"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "identificacion.Gas en finca"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Es cliente" }
                              },
                              [
                                _vm.detalles.cliente
                                  ? _c("b-form-input", {
                                      attrs: {
                                        name: "Es cliente",
                                        value: "SÍ",
                                        disabled: !_vm.hasPermision("B")
                                      }
                                    })
                                  : _c("b-form-input", {
                                      attrs: {
                                        name: "Es cliente",
                                        value: "NO",
                                        disabled: !_vm.hasPermision("B")
                                      }
                                    })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "caldera"
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "Dirección caldera principal" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "Dirección caldera principal",
                                    value: _vm.direccionCaldera,
                                    disabled: !_vm.hasPermision("B")
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "identificacion.Dirección caldera principal"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "caldera"
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "PS con CC en finca" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "PS con CC en finca",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value:
                                      _vm.detalles_ext
                                        .n_usuarios_finca_principal,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.detalles_ext,
                                        "n_usuarios_finca_principal",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detalles_ext.n_usuarios_finca_principal"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "identificacion.PS con CC en finca"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "PS con CC en suministradas" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "PS con CC en suministradas",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value:
                                      _vm.detalles_ext
                                        .n_usuarios_fincas_suministradas,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.detalles_ext,
                                        "n_usuarios_fincas_suministradas",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detalles_ext.n_usuarios_fincas_suministradas"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "identificacion.PS con CC en suministradas"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form",
                          [
                            _c(
                              "b-form-group",
                              {
                                staticStyle: { "font-size": "1rem" },
                                attrs: { label: "PS total CC" }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    "data-vv-scope": "identificacion",
                                    name: "PS total CC",
                                    disabled: !_vm.hasPermision("B")
                                  },
                                  model: {
                                    value: _vm.detalles_ext.n_usuarios_totales,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.detalles_ext,
                                        "n_usuarios_totales",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "detalles_ext.n_usuarios_totales"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "identificacion.PS total CC"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Provincia" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Provincia",
                                options: _vm.provincias_options,
                                "text-field": "entity_name",
                                "value-field": "id",
                                disabled: !_vm.hasPermision("B")
                              },
                              on: {
                                input: function($event) {
                                  _vm.loadMunicipio(false)
                                }
                              },
                              model: {
                                value: _vm.detalles.codigo_provincia_zeus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "codigo_provincia_zeus",
                                    $$v
                                  )
                                },
                                expression: "detalles.codigo_provincia_zeus"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Provincia")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Municipio" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Municipio",
                                "text-field": "entity_name",
                                "value-field": "id",
                                options: _vm.municipio_options,
                                disabled:
                                  _vm.municipio_options.length === 0 ||
                                  !_vm.hasPermision("B")
                              },
                              on: {
                                input: function($event) {
                                  _vm.loadPoblacion(false)
                                }
                              },
                              model: {
                                value: _vm.detalles.codigo_municipio_zeus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "codigo_municipio_zeus",
                                    $$v
                                  )
                                },
                                expression: "detalles.codigo_municipio_zeus"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Municipio")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Población" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Población",
                                "text-field": "entity_name",
                                "value-field": "id",
                                options: _vm.poblacion_options,
                                disabled:
                                  _vm.poblacion_options.length === 0 ||
                                  !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.codigo_poblacion_zeus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "codigo_poblacion_zeus",
                                    $$v
                                  )
                                },
                                expression: "detalles.codigo_poblacion_zeus"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Población")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Dirección no estructurada" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.direccionValidate,
                                  expression: "direccionValidate"
                                }
                              ],
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Dirección no estructurada",
                                disabled: !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.direccion_no_estructurada,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "direccion_no_estructurada",
                                    $$v
                                  )
                                },
                                expression: "detalles.direccion_no_estructurada"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first(
                                    "identificacion.Dirección no estructurada"
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Código postal" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|cod_postal",
                                  expression: "'required|cod_postal'"
                                }
                              ],
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Código postal",
                                disabled: !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.codigo_postal,
                                callback: function($$v) {
                                  _vm.$set(_vm.detalles, "codigo_postal", $$v)
                                },
                                expression: "detalles.codigo_postal"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first(
                                    "identificacion.Código postal"
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Tipo vía" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.direccionValidate,
                                  expression: "direccionValidate"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Tipo vía",
                                options: _vm.tipo_via_options,
                                "text-field": "name_type",
                                "value-field": "name_type",
                                disabled: !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.tipo_via,
                                callback: function($$v) {
                                  _vm.$set(_vm.detalles, "tipo_via", $$v)
                                },
                                expression: "detalles.tipo_via"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Tipo vía")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "autocomplete",
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Nombre vía" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.direccionValidate,
                                  expression: "direccionValidate"
                                }
                              ],
                              attrs: {
                                autocomplete: "off",
                                "data-vv-scope": "identificacion",
                                name: "Nombre vía",
                                disabled: !_vm.hasPermision("B")
                              },
                              on: { input: _vm.loadNames },
                              model: {
                                value: _vm.detalles.nombre_via,
                                callback: function($$v) {
                                  _vm.$set(_vm.detalles, "nombre_via", $$v)
                                },
                                expression: "detalles.nombre_via"
                              }
                            }),
                            _vm._v(" "),
                            _vm.show_names && _vm.type === "comercial"
                              ? _c(
                                  "div",
                                  { staticClass: "autocomplete-items" },
                                  _vm._l(_vm.names_suggestions, function(
                                    element,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        on: {
                                          click: function($event) {
                                            _vm.setElement(element)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              element.street_type.name_type
                                            ) +
                                            " " +
                                            _vm._s(element.street_name) +
                                            " (" +
                                            _vm._s(
                                              element.postal_code_address
                                            ) +
                                            ")\n                        "
                                        )
                                      ]
                                    )
                                  })
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Nombre vía")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Número" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: _vm.direccionValidate,
                                  expression: "direccionValidate"
                                }
                              ],
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Número",
                                disabled: !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.numero,
                                callback: function($$v) {
                                  _vm.$set(_vm.detalles, "numero", $$v)
                                },
                                expression: "detalles.numero"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Número")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Anexo" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: !_vm.hasPermision("B") },
                              model: {
                                value: _vm.detalles.anexo,
                                callback: function($$v) {
                                  _vm.$set(_vm.detalles, "anexo", $$v)
                                },
                                expression: "detalles.anexo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Latitud" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Latitud",
                                disabled: !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.latitud_original,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "latitud_original",
                                    $$v
                                  )
                                },
                                expression: "detalles.latitud_original"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Latitud")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Longitud" }
                          },
                          [
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Longitud",
                                disabled: !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.longitud_original,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "longitud_original",
                                    $$v
                                  )
                                },
                                expression: "detalles.longitud_original"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("identificacion.Longitud")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Precisión coordenadas" }
                          },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "mb-3",
                              attrs: {
                                "data-vv-scope": "identificacion",
                                name: "Precisión coordenadas",
                                options: _vm.coordenadas_options,
                                "text-field": "tipo_precision",
                                "value-field": "id",
                                disabled: !_vm.hasPermision("B")
                              },
                              model: {
                                value: _vm.detalles.id_precision_coordenada.id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles.id_precision_coordenada,
                                    "id",
                                    $$v
                                  )
                                },
                                expression:
                                  "detalles.id_precision_coordenada.id"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "error" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first(
                                    "identificacion.Precisión coordenadas"
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a red dist. en servicio (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.detalles.in_service_mains_distance,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "in_service_mains_distance",
                                    $$v
                                  )
                                },
                                expression: "detalles.in_service_mains_distance"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a red dist. no abandonada (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.detalles.not_abandoned_mains_distance,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "not_abandoned_mains_distance",
                                    $$v
                                  )
                                },
                                expression:
                                  "detalles.not_abandoned_mains_distance"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a red AP en servicio (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.detalles.high_press_main_in_service_dis,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "high_press_main_in_service_dis",
                                    $$v
                                  )
                                },
                                expression:
                                  "detalles.high_press_main_in_service_dis"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a red AP no abandonada (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: "" },
                              model: {
                                value:
                                  _vm.detalles.high_pressure_mains_distance,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.detalles,
                                    "high_pressure_mains_distance",
                                    $$v
                                  )
                                },
                                expression:
                                  "detalles.high_pressure_mains_distance"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _vm.hasPermision("B")
                  ? _c(
                      "b-col",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c("b-button", { on: { click: _vm.cancel } }, [
                          _vm._v("Cancelar")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.save($event)
                              }
                            }
                          },
                          [_vm._v("Guardar")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("br")
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/Details/comercial_identificacion.vue?vue&type=template&id=42e93657&
// module id = null
// module chunks = 